<template>
  <div class="carousel_wrapper">
    <div
      ref="swiper"
      class="carousel-hero carousel-hero--is-hidden swiper-container"
    >
      <div class="carousel-hero-wrapper swiper-wrapper">
        <div
          v-for="box in CarouselBoxes"
          :key="box"
          class="carousel-hero__slide slide swiper-slide"
        >
          <CarouselCard :box="box" :subPage="subPage" />
        </div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
  </div>
</template>
<script>
import Swiper, { Navigation } from "swiper";
import CarouselCard from "@/components/Carousel/CarouselCard.vue";
import "./Carousel.scss";

Swiper.use([Navigation]);

export default {
  name: "Carousel",
  components: {
    CarouselCard,
  },
  props: ["childId", "subPage"],
  data() {
    return {
      swiper: null,
    };
  },
  computed: {
    CarouselBoxes() {
      return this.$store.getters["purl/getPageChildren"](this.childId);
    },
    windowWidth() {
      return this.$store.state.dom.windowWidth;
    },
    slidesOffset() {
      if (this.windowWidth >= 1500) {
        console.log("200");
        return { before: 200, after: 200 };
      } else {
        console.log("0");
        return { before: 0, after: 0 };
      }
    },
  },
  // watch: {
  //   CarouselBoxes: function (CarouselBoxes, oldQuestion) {
  //     console.log("CarouselBoxes", CarouselBoxes);
  //   },
  // },
  mounted() {
    if (this.$refs.swiper !== "undefined") {
      this.$refs.swiper.classList.remove("carousel-hero--is-hidden");
      this.swiper = new Swiper(this.$refs.swiper, {
        // slidesOffsetBefore: this.slidesOffset.before,
        // slidesOffsetAfter: this.slidesOffset.after,
        spaceBetween: 20,
        centerInsufficientSlides: true,
        preventClicks: false,
        preventClicksPropagation: false,
        simulateTouch: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          800: {
            slidesPerView: 2,
          },
          1150: {
            slidesPerView: 3,
          },
          1500: {
            slidesPerView: 4,
          },
        },
      });
    }
  },
  methods: {},
};
</script>

<style  lang="scss" scoped>
.swiper-container {
  overflow: visible;
}
.carousel_wrapper {
  position: relative;
  padding: 0 2em;
  &::before {
    content: "";
    background-image: url("~images/seating-experiences/Gray-bg.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 347px;
    width: 100%;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
}
.slide {
  height: 720px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  // margin: 30px 10px !important;
  // max-width: 400px;
  // margin-bottom: 32px;
  margin-top: 1em;
  margin-bottom: 1em;
}
div[class*="swiper-button"] {
  background: #091419;
  box-shadow: 0 0 44px 0 #008e97;
  border-radius: 20px;
  width: 90px;
  height: 90px;
  @media (max-width: 800px) {
    border-radius: 10px;
    width: 50px;
    height: 50px;
  }
  &.swiper-button-disabled {
    opacity: 0;
  }
}

@media (max-width: 800px) {
  .swiper-button-prev:after,
  .swiper-button-next:after {
    font-size: 20px !important;
  }
}
.swiper-button-next {
  right: 30px;
  @media (max-width: 800px) {
    right: -25px;
  }
}
.swiper-button-prev {
  left: 30px;
  @media (max-width: 800px) {
    left: -25px;
  }
}
</style>
